import LogoIcon from '../svg/WappenBL.svg';

export default LogoIcon;
